import React, { useState, useEffect } from 'react'
import { Modal, Button, Message } from 'semantic-ui-react';
import { useTextResources, useMessageResources } from '../../../language';
import PropTypes from "prop-types";
import './style.css'
import Editor from 'react-simple-wysiwyg';

export const HtmlEditor = ({ value, defaultValue, onChange, ...props }) => {
    // For uncontrolled mode (using defaultValue), maintain internal state
    const [internalValue, setInternalValue] = useState(defaultValue ?? '');

    useEffect(() => {
        if (value === undefined) {
            setInternalValue(defaultValue ?? '');
        }
    }, [defaultValue, value]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        // Update internal state for uncontrolled mode
        if (value === undefined) {
            setInternalValue(newValue);
        }
        if (onChange) {
            // react-simple-wysiwyg v3.x passes event object, extract HTML from e.target.value
            onChange(newValue);
        }
    };
    
    // Support both value (controlled) and defaultValue (uncontrolled) for backward compatibility
    const editorValue = value !== undefined ? value : internalValue;
    
    return <Editor value={editorValue} onChange={handleChange} {...props} />
}

const HtmlEditorPopup = ({ startOpen, onSave, onCancel, value, title, maxLength, ...rest }) => {
    const text = useTextResources()
    const message = useMessageResources()
    const [open, setOpen] = useState(startOpen);
    const [html, setHtml] = useState(value || "")

    useEffect(() => {
        setOpen(startOpen)
    }, [startOpen])

    useEffect(() => {
        setHtml(value || "")
    }, [value])

    const closeAction = () => {
        setOpen(false)
        if (onCancel) {
            onCancel()
        }
    }

    const saveAction = () => {
        setOpen(false)
        if (onSave) {
            onSave(html)
        }
    }

    const exceededMaxLength = () => {
        return maxLength && html?.length >= maxLength;
    }


    return <Modal open={open} {...rest} >
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
            <HtmlEditor value={html} onChange={setHtml} style={{ height: "14em" }} />
            {exceededMaxLength() && <Message warning visible>
                {message("FieldInvalidLength").replace("{0}", text("Description")).replace("{1}", maxLength)}
            </Message>}
        </Modal.Content>
        <Modal.Actions>
            <Button size={"small"} negative onClick={closeAction}>{text("Cancel")}</Button>
            <Button size={"small"} positive disabled={exceededMaxLength()} onClick={saveAction}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal>
}

HtmlEditorPopup.propTypes = {
    startOpen: PropTypes.bool,
    onSave: PropTypes.func,
    title: PropTypes.any,
    value: PropTypes.string,
    onCancel: PropTypes.func,
    maxLength: PropTypes.number
}
HtmlEditor.propTypes = {
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
}
export default HtmlEditorPopup